<template>
<v-list dense class='pa-0' >
  <v-subheader class='overline' v-if='title' >{{title}}</v-subheader>
  <template v-for='program in programs'  >
    <v-list-tile :key='program.id'
      @click='$emit("selected", program)' >
      <v-list-tile-content>
        <v-list-tile-title>{{program.name}}</v-list-tile-title>
        <v-list-tile-sub-title>
          {{dateformat(program.start_date)}} - {{dateformat(program.end_date)}}
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-icon>chevron_right</v-icon>
      </v-list-tile-action>
    </v-list-tile>
    <v-divider :key='`div=${program.id}`' ></v-divider>
  </template>
</v-list>
</template>
<script>
export default {
  name: 'ProgramList',
  props: {
    programs: { type: Array, default: () => { return [] } },
    title: { type: String }
  }
}
</script>



// WEBPACK FOOTER //
// ProgramList.vue?4c534980